import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import { localize } from 'wanderu-i18n';

import { isPartnerEnabled } from '../Partners';

import styles from './PartnerLogo.scss';

function PartnerImage(props) {
    const {
        partner,
        useFullSizeLogo,
    } = props;
    return (
        <>
            <img
                alt={partner.altTag}
                className={classNames(
                    styles.logo,
                    styles.logoDesktop,
                    {
                        [styles.hidden]: useFullSizeLogo,
                        [styles.logoWide]: partner.orientation === 'wide',
                        [styles.logoNormal]: partner.orientation === 'square',
                    },
                )}
                src={partner.main}
            />
            <img
                alt={partner.altTag}
                className={classNames(
                    styles.logo,
                    styles.logoMobile,
                    {
                        [styles.hidden]: !useFullSizeLogo,
                        [styles.logoWide]: partner.orientation === 'wide',
                        [styles.logoNormal]: partner.orientation === 'square',
                    },
                )}
                src={partner.mobile}
            />
        </>
    );
}

PartnerImage.propTypes = {
    partner: PropTypes.shape({
        href: PropTypes.string,
        main: PropTypes.string,
        mobile: PropTypes.string,
        orientation: PropTypes.string,
    }),
    useFullSizeLogo: PropTypes.bool,
};

PartnerImage.defaultProps = {
    partner: {},
    useFullSizeLogo: true,
};

function PartnerLogo(props) {
    const {
        t,
        className,
        partner,
        partnerId,
        flights,
        useFullSizeLogo,
        showSubtext,
    } = props;
    const partnerEnabled = isPartnerEnabled(partnerId);
    return (
        <div className={classNames(styles.cobrandContainer, className)}>
            {showSubtext && (
                <span
                    className={classNames(
                        styles.text,
                        { [styles.hidden]: useFullSizeLogo },
                    )}
                >
                    {flights
                        ? t('flights-powered-by')
                        : t('found-on')}
                </span>
            )}
            {(!flights && partnerEnabled)
                ? (
                    <A
                        className={styles.logoContainer}
                        href={partner.href}
                        title={partnerId}
                    >
                        <PartnerImage
                            partner={partner}
                            useFullSizeLogo={useFullSizeLogo}
                        />
                    </A>
                )
                : (
                    <span
                        className={styles.logoContainer}
                        href={partner.href}
                        title={partnerId}
                    >
                        <PartnerImage
                            partner={partner}
                            useFullSizeLogo={useFullSizeLogo}
                        />
                    </span>
                )}
        </div>
    );
}

PartnerLogo.propTypes = {
    className: PropTypes.string,
    partnerId: PropTypes.string,
    partner: PropTypes.shape({
        href: PropTypes.string,
        main: PropTypes.string,
        mobile: PropTypes.string,
    }),
    flights: PropTypes.bool,
    useFullSizeLogo: PropTypes.bool,
    showSubtext: PropTypes.bool,
};

PartnerLogo.defaultProps = {
    className: '',
    partnerId: '',
    partner: {},
    flights: false,
    useFullSizeLogo: true,
    showSubtext: true,
};

export {
    PartnerImage,
    PartnerLogo,
};
export default localize(PartnerLogo, 'baseApp');
